module.exports = __webpack_public_path__ + "assets/img/profile-connections.adad3966.svg";